
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Icon from './Icon';

interface WelcomeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onStartTour: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose, onStartTour }) => {
    const { t } = useLanguage();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-in fade-in duration-300">
            <div className="w-full max-w-md bg-white dark:bg-[#1d1d1f] rounded-3xl p-8 border border-black/5 dark:border-white/10 shadow-2xl text-center relative overflow-hidden">
                 <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-apple-gold via-yellow-400 to-apple-gold"></div>
                 
                 <div className="w-20 h-20 bg-apple-gold/10 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Icon name="sparkles" className="w-10 h-10 text-apple-gold" />
                 </div>
                 
                 <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">
                    {t('welcomeTitle') || "Welcome to Najeweller AI"}
                 </h2>
                 <p className="text-slate-500 dark:text-slate-400 mb-8 leading-relaxed">
                    {t('welcomeDesc') || "Your personal AI jewelry design studio. Create bespoke designs, generate mockups, and bring your imagination to life."}
                 </p>
                 
                 <div className="flex flex-col gap-3">
                    <button 
                        onClick={onStartTour}
                        className="w-full py-3.5 bg-apple-gold text-black font-bold rounded-xl hover:scale-[1.02] active:scale-95 transition-all shadow-lg shadow-apple-gold/20 flex items-center justify-center gap-2"
                    >
                        <span>{t('startTour') || "Take a Quick Tour"}</span>
                        <Icon name="check" className="w-4 h-4" />
                    </button>
                    <button 
                        onClick={onClose}
                        className="text-sm font-bold text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors py-2"
                    >
                        {t('skipTour') || "Skip for now"}
                    </button>
                 </div>
            </div>
        </div>
    );
};
export default WelcomeModal;
